<template>
	<TheAuth v-if="!walletStore.isLogin" />

	<TheWallet v-else />
</template>

<script setup lang="ts">
import { router } from '@/router';
import type { TRequest } from '@/types';
import TheAuth from './TheAuth.vue';
import TheWallet from './TheWallet.vue';
import { useTelegram } from '@/composables/useTelegram';
import { useWalletStore } from '@/stores/useWalletStore';

const walletStore = useWalletStore();
const { telegram } = useTelegram();

// const start_param = telegram.WebApp.initDataUnsafe.start_param;

// if (start_param) {
// 	try {
// 		const data = JSON.parse(atob(start_param)) as TRequest;

// 		switch (data.method) {
// 			case 'connect_rpc': {
// 				const { id, appName, appUrl, networkByte } = data;

// 				router.replace({
// 					path: '/connect_rpc',
// 					query: {
// 						id,
// 						appName,
// 						appUrl,
// 						networkByte
// 					}
// 				});

// 				break;
// 			}

// 			case 'sign_tx_rpc': {
// 				const { networkByte, id } = data;

// 				router.replace({
// 					path: '/sign_tx_rpc',
// 					query: {
// 						id,
// 						networkByte
// 					}
// 				});

// 				break;
// 			}
// 		}
// 	} catch (error) {
// 		console.error(`start params must be JSON encoded base64`);
// 		console.error(error);
// 	}
// } else {
// 	if (location.hash) {
// 		router.replace('/');
// 	}
// }
</script>
